import React from "react";

export default function DigitalAssets() {
    const baksiapps = [
        {
            name: 'KPU/USO',
            'id' : 'kpu-uso',
            'content-class' : 'flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-kpu-uso-integration-hover duration-300',
            'url-app': 'https://kpu-uso.baktikominfo.id',
            'url-icon': 'assets/images/integrations/kpu-uso.png',
            'url-icon-hover': 'assets/images/integrations/kpu-uso-hover.png',
        },
        {
            name: 'Perbankan',
            'id' : 'jasaperbankan',
            'content-class' : 'flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-perbankan-integration-hover duration-300',
            'url-app': 'https://epnbp.baktikominfo.id/bank',
            'url-icon': 'assets/images/integrations/jasaperbankan.png',
            'url-icon-hover': 'assets/images/integrations/jasaperbankan-hover.png',
        },
        {
            name: 'Kerjasama BU',
            'id' : 'kerjasamabu',
            'content-class' : 'flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-kerjasama-bu-integration-hover duration-300',
            'url-app': 'https://epnbp.baktikominfo.id/kerjasamabu',
            'url-icon': 'assets/images/integrations/kerjasamabu.png',
            'url-icon-hover': 'assets/images/integrations/kerjasamabu-hover.png',
        },
        {
            name: 'Pendapatan Lain-lain',
            'id' : 'pendapatanlainlain',
            'content-class' : 'flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-lain-lain-integration-hover duration-300',
            'url-app': 'https://epnbp.baktikominfo.id/pendapatanlainlain',
            'url-icon': 'assets/images/integrations/pendapatanlainlain.png',
            'url-icon-hover': 'assets/images/integrations/pendapatanlainlain-hover.png',
        }
    ];

    const [isHovering, setIsHovered] = React.useState(false);
    const onMouseEnter = (event) => {
        let divId = event.currentTarget.id;
        let hoverImgUrl = baksiapps.find(integration => integration.id === divId)["url-icon-hover"];

        // Set Img on Hover
        event.currentTarget.querySelector('img').src = window.location.origin + process.env.REACT_APP_BASE_PATH + hoverImgUrl;
        setIsHovered(true);
    }
    const onMouseLeave = (event) => {
        let divId = event.currentTarget.id;
        let unHoverImgUrl = baksiapps.find(integration => integration.id === divId)["url-icon"];

        // Set Img on Hover
        event.currentTarget.querySelector('img').src = window.location.origin + process.env.REACT_APP_BASE_PATH + unHoverImgUrl;
    }

    return (
        <>
            <div className="grid grid-cols-2 gap-4">
                {baksiapps.map((val) => (
                    <a key={val['id']} href={val["url-app"]} id={val['id']} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} target="_blank" rel="noopener noreferrer">
                        <div id={val['id']} className={val["content-class"]}>
                            <img src={window.location.origin + process.env.REACT_APP_BASE_PATH + val["url-icon"]} alt="icon" className="object-scale-down h-16" />
                            <h3 className="flex items-center justify-center ml-3 text-lg font-bold">{val.name}</h3>
                        </div>
                    </a>
                ))}
            </div>
        </>
    );
}